import React from 'react';
import styles from './ProfileGroup.module.scss';
import { ProfileImage, ProfileImageProps } from 'new/elements/ProfileImage';

type ProfileType<T> = ProfileImageProps & T;

interface ProfileGroupProps<T> {
  items: ProfileType<T>[];
  onClickItem?: (data: T) => void;
}

const MAX_SHOWN_ITEMS = 5;

function ProfileContainer<T>(item: ProfileType<T> & { style: any }) {
  return (
    <div style={item.style} className={styles.profileContainer}>
      <ProfileImage
        {...item}
        fullName={item.fullName || ''}
        source={item.source || ''}
        size="small"
      />
    </div>
  );
}

export function ProfileGroup<T>(props: ProfileGroupProps<T>) {
  const onClick = (item) => () => {
    if (props.onClickItem) {
      props.onClickItem(item);
    }
  };

  if (!props.items || !props.items.length) {
    return null;
  }

  return (
    <div className={styles.profileGroup}>
      {props.items.slice(0, MAX_SHOWN_ITEMS).map((item, index) => {
        const name = item.fullName || item.full_name || item.name;
        return (
          <ProfileContainer
            style={{ zIndex: props.items.length - index }}
            key={name || index}
            fullName={name}
            source={item.source}
            onClick={onClick(item)}
          />
        );
      })}
      {props.items.length > MAX_SHOWN_ITEMS ? (
        <ProfileContainer
          style={{ zIndex: 0 }}
          useCleanText
          fullName={`+${props.items.length - 5}`}
          onClick={onClick(undefined)}
        />
      ) : null}
    </div>
  );
}
